import React, { useEffect, useState, useRef } from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Dialog from "@mui/material/Dialog";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { Dropdown, Menu, Drawer, Button, Space, notification } from "antd";
import Pagination from "@mui/material/Pagination";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter, faEdit, faThumbsDown, faThumbsUp, faTrash, faEllipsis, faCloudDownload, faBan, faCloudArrowUp,faCheckCircle, faExclamationCircle, faTimesCircle, faRecycle, faRefresh } from '@fortawesome/free-solid-svg-icons';

import TobNavBar from "../../../DashBaord/Top_navbar";
import ShowData from "../../../../components/ShowData";
import { Link, useNavigate } from "react-router-dom";

import moment from "moment";
import SkeltonList from "../../../../components/SkeltonEffect/list";
import SelectUsers from "../../../../components/SelectUsers";
import { list, addPoints, reversePoints } from "../../../../controllers/V1/recharges/bPointsController";
import {list as UsersList} from "../../../../controllers/V1/users/usersController";
import { getPage } from "../../../../controllers/common";

import ImportPopup from "./import";

import ExportPopup from './Export';
import { formatProjectDate } from "../../../../controllers/common";
import { usePermissions } from "../../../../controllers/PermissionContext";
import ConfirmPopup from "../../../../components/ConfirmPopup";
import { list as generalData } from "../../../../controllers/V1/cms/generalDataController";
function VendorList(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

VendorList.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function BasicTabs() {
  const PERMISSION = usePermissions("rechargePoints");
  const [isFilterShow, setFilterShow] = useState(false);
  const handleFiterDrawer = () => setFilterShow(!isFilterShow);

  const [isExportShow, setExportShow] = useState(false);
  const handleExportDrawer = () => setExportShow(!isExportShow);

  const [isImportShow, setImportShow] = useState(false);
  const handleImportDrawer = () => setImportShow(!isImportShow);

  const [value, setValue] = React.useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const fromRef = useRef();

  const [addEditSection, setAddEditSection] = useState(false);
  const handleAddEditSection = ()=>{
    setAddEditSection(!addEditSection);
    setAddEditData({});
  }
  const [REMARKS, setRemarks] = useState('');

  const [ADDEDITDATA, setAddEditData] = useState({});

  const handleAddChange = (e) =>{
    const { name, value} = e.target;
    setAddEditData((pre)=>({
      ...pre,
      [name]   : value
    }));
    
  }

  /************************************************************************************* */
  const [isLoading, setIsLoading] =useState(true);
  const targetRef = useRef(null);
  const inputRef1 = useRef(null);
  const inputRef2 = useRef(null);
  const inputRef3 = useRef(null);
  const inputRef4 = useRef(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [ALLLISTDATA, setListData] = useState([]);
  const [TOTALPAGES, setTotalPages] = useState(1);
  const [LIMIT, setLimit] = useState(10);
  const [SKIP, setSkip] = useState(0);
  const [filter, setFilter] = useState({
    from: "",
    to: new Date(),
    filter_by: "",
    search: "",
  }); //End

  const [showRequest, setShowRequest] = useState("");
  const [fromDate, setFromDate] = useState(`${moment().startOf('day').format('YYYY-MM-DD HH:mm:ss')}`);
  const [toDate, setToDate] = useState(`${moment().endOf('day').format('YYYY-MM-DD HH:mm:ss')}`);
  const [confirmPopup, setConfirmPopup] = useState(false);
  const toggleConfirmPopup = () => setConfirmPopup(!confirmPopup);
  const [reverseID, setReverseID] = useState('');

  /*********************************************************
   *  This function is use to fetch vendor list
   *********************************************************/
  const getList = async () => {
    try {
      setIsLoading(true);
      setListData([]);
      let userList = [];
      if(filter?.filter_by === 'name' || filter?.filter_by === 'mobile' || filter?.filter_by === 'email'){
        const userOption = {
          condition : { 
            ...(filter?.filter_by === 'name'?{users_name : { $regex: filter?.search, $options: "i" } }:null),
            ...(filter?.filter_by === 'mobile'?{users_mobile : parseFloat(filter?.search) }:null),
            ...(filter?.filter_by === 'email'?{users_email : { $regex: filter?.search, $options: "i" } }:null),
          },
          select : {_id : true}
        }
        const usrRes = await UsersList(userOption);
        if(usrRes.status === true){
          const usrList = usrRes.result
          if(usrList.length > 0){
            userList = usrList.map((item)=>item._id);
          }
        }
      }
      // console.log('filter',filter);
      const options = {
        type: "",
        condition: {
          ...(filter?.filter_by === 'points'?{ points :  parseFloat(filter?.search) }:null),
          ...(filter?.filter_by === 'availableArabianPoints'?{availableArabianPoints : parseFloat(filter?.search) }:null),
          ...(filter?.filter_by === 'end_balance'?{end_balance : parseFloat(filter?.search) }:null),
          ...(filter?.filter_by === 'record_type'?{record_type : { $regex: filter?.search, $options: "i" } }:null),
          ...(filter?.filter_by === 'narration'?{narration : { $regex: filter?.search, $options: "i" } }:null),
          ...(filter?.filter_by === 'created_by_users_type'?{created_by_users_type : { $regex: filter?.search, $options: "i" } }:null),

          ...(userList?.length > 0 && {$or :[
            { credit_user : {$in : userList} },
            { debit_user : {$in : userList} },
          ]}),

          ...(filter?.from && {createdAt : {$gte : filter.from, $lte : filter.to} }),
          ...(showRequest ? { status: showRequest } : null),
        },
        select: {},
        sort: { _id: -1 },
        skip: SKIP ? SKIP : 0,
        limit: LIMIT ? LIMIT : 10,
      };
      const listData = await list(options);
      if (listData.status === true) {
        if (listData.result.length > 0) {
          setListData(listData?.result);
          setTotalPages(getPage(listData?.count, LIMIT))
        } else {
          setListData([]);
          setTotalPages(getPage(1))
        }
      } else {
        setListData([]);
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  }; //End

  /*********************************************************
   *  This function is for handle page change
   *********************************************************/
  const handlePageChange = (event, newPage) => {
    setCurrentPage(newPage);
    setSkip((newPage - 1) * LIMIT);
    targetRef.current.scrollIntoView({
      behavior: "smooth",
    });
  };

  /*********************************************************
   *  This function is ued for handle filter input change
   *********************************************************/
  const handleFilterReset = () => {
    try {
      setFilter('');
      setFromDate("");
      setToDate("");
      inputRef1.current.value = '';
      inputRef2.current.value = '';
      inputRef3.current.value = '';
      inputRef4.current.value = '';
    } catch (error) {
      
    }
  }

  const handleFilterApply = (e) => {
    try {
      e.preventDefault();
      const form = new FormData(e.target);
      const to = moment(form.get('to_date')).format('YYYY-MM-DD HH:mm:ss')
      const from = moment(form.get('from_date')).format('YYYY-MM-DD HH:mm:ss')
      setFilter((pre) => ({
        ...pre,
        filter_by: form.get("filter_by") || "",
        search: form.get("search") || "",
        'to'        : form.get('to_date') ? moment(to).format('YYYY-MM-DD HH:mm:ss') : '',
        'from'      : form.get('from_date') ? moment(from).format('YYYY-MM-DD HH:mm:ss') : ''
      }));
      handleFiterDrawer();
      setSkip(0);
    } catch (error) {
      
    }
  }

  const getGeneralData = async () => {
    try {
      const res = await generalData();
      if(res?.status === true){
        const { draw_start_time, draw_end_time } = res.result;
        if(draw_start_time) setFromDate(`${moment().format('YYYY-MM-DD')} ${draw_start_time}`)
        if(draw_end_time) setToDate(`${moment().format('YYYY-MM-DD')} ${draw_end_time}`)
      }  
    } catch (error) {
      
    }
  }
  useEffect(()=>{
    getGeneralData();
  },[])

  /*********************************************************
   *  This function will load when page load and with dependency update
   *********************************************************/
  useEffect(() => {
    getList();
    targetRef.current.scrollIntoView({
      behavior:'smooth',
    });
    document.title = "Crown King || QR-Point's list";
  }, [currentPage, showRequest, filter, addEditSection, LIMIT]);


  const [totalAvailablePoints, setTotalAvailablePoints] = useState(0);
  useEffect(()=>{
    const point = parseFloat(ADDEDITDATA.points);
    const commission = parseInt(ADDEDITDATA.commission);
    let total_points = point;
    if(commission > 0){
      total_points = point + point*commission/100;
    }
    setAddEditData((pre)=>({
      ...pre,
      'total_points'   : total_points || 0
    }));
    if(ADDEDITDATA?.userData){
      const userData = JSON.parse(ADDEDITDATA?.userData || "");
      setTotalAvailablePoints(userData?.availableArabianPoints || 0);
    }
  },[ADDEDITDATA.points, ADDEDITDATA.commission, ADDEDITDATA.userData])

  const handleRecharge = async () =>{
    try {
      const params = {
        user_id : ADDEDITDATA?.bind_person_id || '',
        points : ADDEDITDATA?.total_points,
        ...(ADDEDITDATA?.commission && {commission : ADDEDITDATA?.commission}),
        ...(ADDEDITDATA?.remarks && {remarks : ADDEDITDATA?.remarks})
      }
      const isValidate = await validateRechargeData(params);
      if(isValidate){
        const res = await addPoints(params);
        if(res.status === true){
          notification.open({
            message: "Success",
            description: `QR-Point added successfully.`,
            placement: "topRight",
            icon: <FontAwesomeIcon icon={faCheckCircle} style={{ color: "green" }} />,
            duration: 2,
          });
          handleAddEditSection();
        } else{
          notification.open({
            message: "Oops!",
            description: `${res?.message}`,
            placement: "topRight",
            icon: <FontAwesomeIcon icon={faExclamationCircle} style={{ color: "red" }} />,
            duration: 2,
          });
        }
      }
    } catch (error) {
      notification.open({
        message: "Oops!",
        description: `Error occur while procession.`,
        placement: "topRight",
        icon: <FontAwesomeIcon icon={faExclamationCircle} style={{ color: "red" }} />,
        duration: 2,
      });
    }
  }

   const validateRechargeData = (option) =>{
    try {
      const { user_id, points } = option;
      if(!user_id){ 
        notification.open({
          message: "Oops!",
          description: `Please select an user.`,
          placement: "topRight",
          icon: <FontAwesomeIcon icon={faExclamationCircle} style={{ color: "red" }} />,
          duration: 2,
        });
        return false;
      } else if(!points || points < 1){
        notification.open({
          message: "Oops!",
          description: `QR-Points .`,
          placement: "topRight",
          icon: <FontAwesomeIcon icon={faExclamationCircle} style={{ color: "red" }} />,
          duration: 2,
        });
        return false;
      }else {
        return true;
      }
    } catch (error) {
      notification.open({
        message: "Oops!",
        description: `Error while validate the data.`,
        placement: "topRight",
        icon: <FontAwesomeIcon icon={faExclamationCircle} style={{ color: "red" }} />,
        duration: 2,
      });
      return false;
    }
   }
   const handleReverse = async () => {
    try {
      setIsLoading(true);
      if(!reverseID){
        notification.open({
          message: "Oops!",
          description: `Data not found.`,
          placement: "topRight",
          icon: <FontAwesomeIcon icon={faExclamationCircle} style={{ color: "red" }} />,
          duration: 2,
        });
      } else{
        const options = { id : reverseID };
        const res = await reversePoints(options);
        if(res.status === true){
          getList();
          notification.open({
            message: "Success",
            description: `User updated successfully..`,
            placement: "topRight",
            icon: <FontAwesomeIcon icon={faCheckCircle} style={{ color: "green" }} />,
            duration: 2,
          });
        } else {
          notification.open({
            message: "Oops!",
            description: `${res.message}`,
            placement: "topRight",
            icon: <FontAwesomeIcon icon={faExclamationCircle} style={{ color: "red" }} />,
            duration: 2,
          });
        }
        setIsLoading(false);
        // alert('Reverse');
      }
    } catch (error) {
      setIsLoading(false);
    }
   }

   const handleFilterChange = (e) =>{
       const {name, value} = e.target;
       if(name === 'from_date'){
         setFromDate(`${moment(value).format('YYYY-MM-DD HH:mm:ss')}`)
       } else if(name === 'to_date'){
         setToDate(`${moment(value).format('YYYY-MM-DD HH:mm:ss')}`)
       } else {
         setFilter((pre)=>({
           ...pre,
           [name] : value
         }))
       }
    }

    const handleSubmit = (e)=> e.preventDefault();
  
    const handleReset = () => {
      fromRef.current.reset();
      setAddEditData({});
      setTotalAvailablePoints(0);
    }
  return (
    <>
      <div className="container-fluid" ref={targetRef}>
        <TobNavBar title={"QR-Points History"}></TobNavBar>
        <div className="inventory_tabs_main_div">
          <Box sx={{ width: "100%" }}> 

            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <div className="inventory_all_tabs">
                <div className="all_tabs_value">
                  <Tabs
                    value={value}
                    onChange={handleChange}
                    aria-label="basic tabs example"
                    className="item_tabs_main_container"
                  >
                    <Tab
                      label="All"
                      className="tabs_main_contnet"
                      {...a11yProps(0)}
                      onClick={() => setShowRequest("")}
                    />
                  </Tabs>
                </div>

                <div className="fa_filter_rating_review filter_img_and_add_btn_main">
                  <div>
                    <ShowData setLimit={setLimit} limit={LIMIT} />
                  </div>
                  <div className="inventory_filter_div" onClick={handleFiterDrawer}>
                    <FontAwesomeIcon icon={faFilter} />
                    <Link
                      to={false}
                      className="filter_btn_invontry_rating_review"
                    >
                      Filter
                    </Link>
                  </div>
                  {(PERMISSION?.fullAccess === 'Y' || PERMISSION?.export === 'Y') && (
                    <div className="inventory_filter_div" onClick={handleExportDrawer}>
                      <FontAwesomeIcon icon={faCloudDownload} />
                      <Link
                        to={false}
                        className="filter_btn_invontry_rating_review"
                      >
                        Export
                      </Link>
                    </div>
                  )}
                  {(PERMISSION?.fullAccess === 'Y' || PERMISSION?.import === 'Y') && (
                    <div className="inventory_filter_div" onClick={handleImportDrawer}>
                      <Link to={false} class="filter_btn_invontry_rating_review">
                        <FontAwesomeIcon icon={faCloudArrowUp} />
                        Upload
                      </Link>
                    </div>
                  )}

                  {(!addEditSection && (PERMISSION?.fullAccess === 'Y' || PERMISSION?.addEdit === 'Y')) && (
                    <div onClick={handleAddEditSection}>
                      <button type="button" class="btn btn-dark">
                        <span className="request_new_categories">Add New</span>
                      </button>
                    </div>
                  )}
                  <div className="inventory_filter_div"> 
                    <Link to={false} 
                      onClick={handleReset}

                    ><FontAwesomeIcon icon={faRefresh}/></Link>
                  </div>
                </div>
              </div>
            </Box> 
            {(addEditSection && (PERMISSION?.fullAccess === 'Y' || PERMISSION?.addEdit === 'Y')) && (<>
              <br/>
              <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                <form onSubmit={handleSubmit} ref={fromRef}>
                  <div className="row inventory_all_tabs">
                    <div className="form-group row">
                      <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                        <label for="users_type" className="all_lable_for_vendor_dashbaord" > User's type : </label>
                        <select name="users_type" id="users_type" onChange={handleAddChange} className="form-control categories_select_tg_enter_product">
                          <option value='' selected >Choose user's type</option>
                          <option value='Freelancer'>Freelancer</option>
                          <option value='Sales Person'>Sales Person</option>
                          <option value='Retailer'>Retailer</option>
                          <option value='Promoter'>Promoter</option>
                          <option value='Users'>Users</option>
                          <option value='Tester'>Tester</option>
                        </select>
                      </div>

                      <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                        <label for="users_type" className="all_lable_for_vendor_dashbaord" > <span style={{color : 'red'}}>*</span> Select user : </label>
                        <SelectUsers user_type={ADDEDITDATA?.users_type || ''} setAddEditData={setAddEditData}  />
                      </div>

                      <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                        <label for="points" className="all_lable_for_vendor_dashbaord" > <span style={{color : 'red'}}>*</span> QR-Points : </label>
                        <input type="number" name="points" id="points" onChange={handleAddChange} placeholder=" QR-Points" className="form-control categories_select_tg_enter_product" />
                      </div>

                      {/* <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                        <label for="commission" className="all_lable_for_vendor_dashbaord" > Commission Awarded : </label>
                        <select name="commission" id="commission" onChange={handleAddChange} className="form-control categories_select_tg_enter_product" >
                          <option value='' selected disabled>Choose commission</option>
                          <option value={5}>5%</option>
                          <option value={10}>10%</option>
                          <option value={15}>15%</option>
                          <option value={20}>20%</option>
                        </select>
                      </div> */}

                      <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                        {/* <label for="total_points" className="all_lable_for_vendor_dashbaord" > <span style={{color : 'red'}}>*</span> Sub-Total QR-Points : </label> */}
                        <input type="hidden" value={ADDEDITDATA?.total_points} name="total_points" id="total_points" placeholder="Sub-Total QR-Points" className="form-control categories_select_tg_enter_product" readOnly />
                      </div>

                      <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <label for="remarks" className="all_lable_for_vendor_dashbaord" > Remarks : </label>
                        <textarea name="remarks" id="remarks" placeholder="Enter your remarks." onChange={handleAddChange} className="form-control categories_select_tg_enter_product" />
                      </div>
                      <div className="col-lg-8 col-md-8 col-sm-8 col-xs-12">
                        {(ADDEDITDATA?.bind_person_id && totalAvailablePoints > 0) && (
                          <h3 className="mt-3">Total available balance : {totalAvailablePoints.toFixed(2)}</h3>
                        )}
                      </div>
                      <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                        <div className="inventory_open_popup_action_btn">
                          <button type="button" className="btn btn-light categories_cancel_button" onClick={handleAddEditSection} > Cancel </button>
                          <button type="button" className="btn btn-danger" onClick={handleRecharge} > Submit </button>
                        </div>
                      </div>

                    </div>

                  </div>
                </form>
              </Box>
            </>)}

            <VendorList 
              >
              <div>
                <div id="content-wrapper" className="d-flex flex-column">
                  <div className="card shadow mb-4">
                    <div className="card-body pt-0">
                      <div className="table-responsive">
                        <table
                          className="table table-bordered"
                          id="dataTable"
                          width="100%"
                          cellspacing="0"
                        >
                          <thead>
                            <tr>
                              <th>Sl. No.</th>
                              <th>Points</th>
                              <th>Recharge By</th>
                              <th>QR-Points</th>
                              <th>Record Type</th>
                              <th>User Details</th>
                              {/* <th>Commission %</th> */}
                              <th>Remarks</th>
                              <th>Created Date & Time</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {ALLLISTDATA?.length > 0 ? (
                              ALLLISTDATA.map((items, index) => (
                                <>
                                  <tr key={index} >
                                    <td>{index + 1}</td>
                                    <td>{items?.points.toFixed(2)}</td>
                                    {items?.created_by_users_type === 'Admin'?(
                                      <td className="admin_user_list_date"> Admin </td>  
                                    ):(
                                      <td className="admin_user_list_date"> 
                                        <span>{`${items?.users_name} ${items?.last_name}`}</span><br/>
                                        <span>{items?.users_mobile}</span><br/>
                                        {items?.users_email && (<span>{items?.users_email}</span>)}
                                      </td>
                                    )}
                                    <td className="admin_user_list_date">
                                      Avl : {items?.availableArabianPoints?.toFixed(2)}<br/>
                                      End : {items?.end_balance?.toFixed(2)}
                                    </td>        

                                    <td className="admin_user_list_date">
                                      {items?.record_type} <br/>
                                      {items?.narration}
                                    </td>
                                    
                                    {items?.record_type === 'Credit'?(
                                      <td className="admin_user_list_date">
                                        {items.credit_user?.users_name}<br/>
                                        {items.credit_user?.users_mobile}
                                      </td>
                                    ):(
                                      <td className="admin_user_list_date">
                                        {items.debit_user?.users_name}<br/>
                                        {items.debit_user?.users_mobile}
                                      </td>
                                    )}
                                    {/* {items?.commission_details?(
                                      <td className="admin_user_list_date">
                                        Percentage : {items.commission_details?.percentage} %<br/>
                                        Amount : {items.commission_details?.amount?.toFixed(2)}
                                      </td>
                                    ):(
                                      <td>-</td>
                                    )} */}
                                    <td className="admin_user_list_date" style={{textAlign : 'center'}}>
                                      {items?.remarks ? (<Link to={false} onClick={()=>setRemarks(items?.remarks)}>Show</Link>)
                                    : '-' }
                                   </td>
                                    <td className="admin_user_list_date">{moment(formatProjectDate(items?.createdAt)).format('DD-MM-YYYY hh:mm A')}</td>
                                    <td>
                                      <Dropdown
                                        placement="bottomLeft"
                                        arrow
                                        overlay={
                                          <Menu>
                                            {(items?.narration === "Recharge" && (PERMISSION?.fullAccess === 'Y' || PERMISSION?.reverse === 'Y')) && (
                                              <Menu.Item key={`1`} onClick={() => {
                                                setReverseID(items?._id);
                                                toggleConfirmPopup();
                                                }} >
                                                <FontAwesomeIcon icon={faRecycle} /> <span className="show_span">Reverse</span>
                                              </Menu.Item>
                                            )}
                                          </Menu>
                                        }
                                      >
                                        <FontAwesomeIcon icon={faEllipsis} />
                                      </Dropdown>
                                    </td>
                                  </tr>
                                </>
                              ))
                            ) : isLoading ? <SkeltonList row={5} col={10} /> : <tr> 
                                <td colspan="10" className="img-center" >No data found !</td> 
                            </tr>}
                          </tbody>
                        </table>
                        <div className="table_pagination_sales_order">
                          <Pagination
                            count={TOTALPAGES}
                            onChange={handlePageChange}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </VendorList>
          </Box>
        </div>
      </div>
      {/* Remarks Popup */}
      <Dialog
        open={REMARKS === '' ? false:true}
        onClose={()=>setRemarks('')}
        fullWidth={true}
        maxWidth={"sm"}
        PaperProps={{
          className: "myDialogPopUp",
        }}
      >
      <div className="myDrawer">
        
        <div className="myDrawer">
          <div className="inventory_popup_title">
            <Typography
              variant="h5"
              component="div"
              gutterBottom
              className="inventory_popup_title_heading"
            >
              Recharge Review 
            </Typography>
            <Link to={false} style={{ position: "absolute", right: 8, top: 8, color: "#dd5151" }} onClick={()=>setRemarks('')} >
            <FontAwesomeIcon icon={faTimesCircle}/>
            </Link>
          </div>

          <Typography
            variant="body1"
            component="div"
            className="my_delete_popup_paragraph"
          >
            <div className="container-fluid">
              <div className="categories_open_popup_main_contnet">
                <div className="form-group row">
                  <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <span>{REMARKS}</span>
                  </div>
                </div>
                <br/>
              </div>
            </div>
          </Typography>
        </div>
      </div>
    </Dialog>
      {/* Export*/}
      <ExportPopup popUpOpen={isExportShow} togglePopUp={handleExportDrawer} />
      <ImportPopup popUpOpen={isImportShow} togglePopUp={handleImportDrawer} getList={getList} />
      <ConfirmPopup popUpOpen={confirmPopup} togglePopUp={toggleConfirmPopup} process={handleReverse} />
      {/* Filter */}
      <Drawer
        title="Filter"
        placement={`right`}
        width={500}
        onClose={handleFiterDrawer}
        open={isFilterShow}
        extra={
          <Space>
            <Button onClick={handleFiterDrawer}>Cancel</Button>
            <Button type="primary" onClick={handleFilterReset}  style={{ backgroundColor: 'var(--brand-red)', color: 'white' }}>
              Reset
            </Button>
          </Space>
        }
      >
        <div className="responsive">
          <div className="row">
            <form id='filter_form' onSubmit={handleFilterApply}>
              <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <label htmlFor="vendor_first_name" className="all_section_for_label_main_class" >
                  Search Field :
                </label>
                <select name="filter_by" className="form-control store_input_field" id="filter_by" ref={inputRef1}>
                  <option value=''>Select search field</option>
                  <option value='points' selected={filter?.filter_by ==='points'?true:false}>Points</option>
                  <option value='availableArabianPoints' selected={filter?.filter_by ==='availableArabianPoints'?true:false}>Avl. Points</option>
                  <option value='end_balance' selected={filter?.filter_by ==='end_balance'?true:false}>End Points</option>
                  <option value='record_type' selected={filter?.filter_by ==='record_type'?true:false}>Record Type</option>
                  <option value='narration' selected={filter?.filter_by ==='narration'?true:false}>Narration</option>
                  <option value='created_by_users_type' selected={filter?.filter_by ==='created_by_users_type'?true:false}>Created By</option>
                  <option value='name' selected={filter?.filter_by ==='name'?true:false}>Name</option>
                  <option value='mobile' selected={filter?.filter_by ==='mobile'?true:false}>Mobile</option>
                  <option value='email' selected={filter?.filter_by ==='email'?true:false}>Email</option>
                </select>
              </div>
              <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <label htmlFor="vendor_first_name" className="all_section_for_label_main_class" >
                  Search Text :
                </label>
                <input
                  title="Enter search text."
                  placeholder="Enter search text."
                  type="text"
                  name="search"
                  className="form-control store_input_field"
                  id="search"  
                  ref={inputRef2}
                />
              </div>
              <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <label htmlFor="vendor_first_name" className="all_section_for_label_main_class" >
                  From :
                </label>
                <input
                  title="Enter search text."
                  type="datetime-local"
                  name="from_date"
                  value={fromDate}
                  onChange={handleFilterChange}
                  className="form-control store_input_field"
                  id="from_date"      
                  ref={inputRef3}
                />
              </div>
              <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <label htmlFor="vendor_first_name" className="all_section_for_label_main_class" >
                  To :
                </label>
                <input
                  title="Enter search text."
                  type="datetime-local"
                  name="to_date"
                  value={toDate}
                  onChange={handleFilterChange}
                  className="form-control store_input_field"
                  id="to_date"   
                  ref={inputRef4}
                />
              </div>
              <br/>
              <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <button
                  title="Enter search text."
                  type="submit"
                  className="form-control btn btn-black"    
                  style={{ backgroundColor: "var(--brand-red-dark)", color: "white" }}           
                >Apply</button>
              </div>
            </form>
          </div>
        </div>
      </Drawer>
    </>
  );
}
